// extracted by mini-css-extract-plugin
export var collapsedSummary = "_ol-0";